export type TAILessonPromptingRenderType = "text" | "image" | "audio";

export interface TAILessonPromptingConfig {
  statement?: string;
  renderType: TAILessonPromptingRenderType;
  keywords: string[];
  requiredKeywords: number;
  answerText?: string; // Deprecated: use answerTexts instead
  answerTexts?: string[]; // Array of texts for progressive reveal (index 0 = 1 keyword, index 1 = 2 keywords, etc.)
  answerImage?: string;
  answerAudio?: string;
}

export const createEmptyAILessonPromptingConfig = (): TAILessonPromptingConfig => ({
  statement: "",
  renderType: "text",
  keywords: [],
  requiredKeywords: 0,
  answerText: "",
  answerTexts: [],
  answerImage: "",
  answerAudio: "",
});
